import { useContext } from "react";
import Modal from "react-modal";
import AppGlobalsContext from "app/AppGlobalsContext";
import AuthModal from "app/pages/Auth/AuthModal/AuthModal";
import AuthLayerMobile from "app/pages/Auth/AuthLayerMobile/AuthLayerMobile";
import Paragraphs from "app/pages/.shared/Paragraphs";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import type { MembershipSignupTexts } from "../types";

const SHOP_WITH_ATOL_ABTA = "en-GB";

const ABOVE_HEADER_AND_MARKETING_BANNER: Modal.Styles = { overlay: { zIndex: 6 } };

type MembershipSignupDialogProps = {
	isOpen: boolean;
	isMobile: boolean;
	onClose: () => void;
	texts?: MembershipSignupTexts;
};

const SignupMarketing = ({ title = [], description = [] }: MembershipSignupTexts) => (
	<div className="auth-modal__marketing">
		<div className="auth-modal__marketing-content">
			{title.length > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL3}
					variantMD={TYPOGRAPHY_VARIANTS.XL4}
					isBold
				>
					<div className="auth-modal__marketing-title">
						<Paragraphs paragraphs={title} enableHTMLFormatting />
					</div>
				</Typography>
			)}
			{description.length > 0 && (
				<div className="auth-modal__marketing-description">
					<Paragraphs paragraphs={description} enableHTMLFormatting />
				</div>
			)}
		</div>
	</div>
);

/** Signup form opened from the membership block: a full screen layer on mobile, a modal on desktop. */
export const MembershipSignupDialog = ({
	isOpen,
	isMobile,
	onClose,
	texts = {},
}: MembershipSignupDialogProps) => {
	const { shop } = useContext(AppGlobalsContext);
	const showAtolAbta = shop === SHOP_WITH_ATOL_ABTA;
	const marketing = <SignupMarketing {...texts} />;

	if (isMobile) {
		return (
			<Modal isOpen={isOpen} style={ABOVE_HEADER_AND_MARKETING_BANNER}>
				<AuthLayerMobile
					onAuthSuccess={onClose}
					onClose={onClose}
					showAtolAbta={showAtolAbta}
					signinMarketingBlock={marketing}
					signupMarketingBlock={marketing}
				/>
			</Modal>
		);
	}

	return (
		<AuthModal
			isOpen={isOpen}
			onAuthSuccess={onClose}
			onClose={onClose}
			showAtolAbta={showAtolAbta}
			signinMarketingBlock={marketing}
			signupMarketingBlock={marketing}
		/>
	);
};
